<template>
  <AppPopover
    id="members-info-popover"
    ref="AppPopover"
    placement="top"
    hide-close
    hide-from-action
    data-tipclass="member-popover-tooltip"
  >
    <template #trigger>
      <div
        v-tooltip="{ closeOnClick: true }"
        class="about-fields"
        title="View details"
        data-tipclass="member-popover-tooltip"
      >
        <div
          v-for="(info, index) in visibleAboutFields(memberData)"
          :key="`${info.value}-${index}`"
          class="about-fields-data"
        >
          {{ info.value }}
        </div>
      </div>
    </template>
    <div class="d-flex align-items-center my-15">
      <div class="mr-10">
        <AppAvatar
          :avatar="memberData.avatar_url"
          size="medium"
        />
      </div>
      <div class="info-popover-header">
        <div class="popover-type">Member About</div>
        <div class="member-name">{{ userName }}</div>
      </div>
    </div>
    <div class="about-fields">
      <div
        v-for="(info, index) in visibleAboutFields(memberData)"
        :key="`${info.value}-${index}`"
        class="about-fields-data"
      >
        <span class="info-title">{{ info.title }}</span>
        <span class="info-value">{{ info.value }}</span>
      </div>

      <div class="mt-30 mb-20">
        <a
          class="text-lighter strong"
          :href="memberProfileLink"
          target="_blank"
        >
          View profile
        </a>
      </div>
    </div>
  </AppPopover>
</template>
<script>
import { filter } from 'lodash-es';
import { formatDate } from '~/utils/time_utils';
import dayjs from 'dayjs';
import { mapState } from 'vuex';
import { PopoverAvatarUserCardResource } from '~/resources';

export default {
  name: 'MemberAboutData',
  props: {
    // Map of enabled fields, have show_ prefix {show_field_key: true/false}
    aboutFields: {
      type: Object,
      required: true,
    },
    memberData: {
      type: Object,
      required: true,
    },
    customVisibleByDefault: {
      type: Boolean,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      default: 'left',
    },
    userId: {
      type: Number,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tooltipOptions: Object.freeze({ placement: this.tooltipPlacement, html: true }),
    };
  },
  computed: {
    ...mapState(['organization']),
    memberProfileLink() {
      return PopoverAvatarUserCardResource.memberProfileLink({
        userId: this.userId,
        organizationId: this.organization.id,
        tab: 'info',
      });
    },
  },
  methods: {
    visibleAboutFields(member) {
      const memberFields = this.aboutFieldsGroup(member);

      return filter(memberFields, (field) => field.value && this.isEnabled(field));
    },
    isEnabled(field) {
      const enabled = this.aboutFields[`show_${field.key}`];

      return field.key.startsWith('custom_') ? enabled ?? this.customVisibleByDefault : enabled;
    },
    aboutFieldsGroup(member) {
      const profileFields = this.organization?.member_profile_fields || [];
      const customFields = profileFields.map((field) => ({
        key: `custom_${field.key}`,
        title: field.title,
        value: member.custom_fields[field.key],
      }));

      return [
        { key: 'email', title: 'Email', value: member.email },
        { key: 'job_title', title: 'Job title', value: member.job_title },
        { key: 'job_type', title: 'Job type', value: member.job_type },
        { key: 'employee_id', title: 'Employee ID', value: member.employee_id },
        { key: 'tax_info', title: 'Tax info', value: member.tax_info },
        { key: 'location', title: 'Location', value: member.location },
        { key: 'timezone', title: 'Time zone', value: member.time_zone },
        { key: 'date_added', title: 'Date added', value: formatDate(dayjs(member.date_added)) },
        { key: 'date_removed', title: 'Date removed', value: formatDate(dayjs(member.date_removed)) },
        ...customFields,
      ];
    },
  },
};
</script>
